import React from "react";
import { Box, Inline, Text } from "braid-design-system";
import { useAuth } from "../contexts/AuthProvider";

const LogoutButton: React.FC = () => {
    const [loading, setLoading] = React.useState(false);
    const [menuOpen, setMenuOpen] = React.useState(false);
    const { logout, user } = useAuth();

    const handleLogout = async () => {
        try {
            setLoading(true);
            await logout();
        } catch (error: any) {
            alert(error.message || "Logout failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Inline space="none">
            <div style={{ position: 'relative', display: 'inline-block' }}>
                <Box 
                    userSelect="none" 
                    cursor="pointer" 
                    onClick={() => setMenuOpen(!menuOpen)}
                    style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        width: '36px', 
                        height: '36px', 
                        borderRadius: '50%', 
                        background: 'linear-gradient(135deg, #0f2a6a, #1e3a8a)', 
                        boxShadow: '0 2px 8px rgba(15, 42, 106, 0.2)',
                        border: '2px solid #ffffff',
                        transition: 'transform 0.2s ease'
                    }}
                >
                    <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="18" width="18" xmlns="http://www.w3.org/2000/svg" style={{ color: '#ffffff' }}>
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                </Box>

                {menuOpen && (
                    <>
                        {/* Backdrop to close the menu when clicking outside */}
                        <div 
                            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 }} 
                            onClick={() => setMenuOpen(false)}
                        />
                        <div 
                            style={{ 
                                position: 'absolute', 
                                right: 0, 
                                top: '44px', 
                                backgroundColor: '#ffffff', 
                                borderRadius: '12px', 
                                boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.05)', 
                                border: '1px solid #e2e8f0', 
                                padding: '16px', 
                                minWidth: '220px', 
                                zIndex: 1000,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '12px',
                                animation: 'fadeInUp 0.15s ease-out'
                            }}
                        >
                            <style>{`
                                @keyframes fadeInUp {
                                    from { opacity: 0; transform: translateY(8px); }
                                    to { opacity: 1; transform: translateY(0); }
                                }
                            `}</style>
                            
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                <Text size="xsmall" tone="secondary" weight="strong">
                                    SIGNED IN AS
                                </Text>
                                <Text size="standard" weight="strong" tone="brandAccent">
                                    {user?.name || user?.user_name || 'username'}
                                </Text>
                                <Text size="xsmall" tone="secondary">
                                    @{user?.user_name}
                                </Text>
                                {user?.active_branch?.name_ln1 && (
                                    <Box style={{ borderTop: '1px solid #f1f5f9', paddingTop: '6px', marginTop: '4px' }}>
                                        <Text size="xsmall" tone="secondary">
                                            Branch: {user.active_branch.name_ln1}
                                        </Text>
                                    </Box>
                                )}
                            </div>

                            <button 
                                onClick={handleLogout} 
                                disabled={loading}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    width: '100%',
                                    padding: '8px 12px',
                                    borderRadius: '6px',
                                    border: '1px solid #fee2e2',
                                    backgroundColor: '#fef2f2',
                                    color: '#ef4444',
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s, transform 0.1s'
                                }}
                                onMouseEnter={(e: any) => e.currentTarget.style.backgroundColor = '#fee2e2'}
                                onMouseLeave={(e: any) => e.currentTarget.style.backgroundColor = '#fef2f2'}
                            >
                                <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="16" width="16" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                    <polyline points="16 17 21 12 16 7"></polyline>
                                    <line x1="21" y1="12" x2="9" y2="12"></line>
                                </svg>
                                {loading ? "Logging out..." : "Logout"}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </Inline>
    );
};

export default LogoutButton;
